import styled from 'styled-components'

export const ErrorMessageStyled = styled.div.attrs((props) => ({
    // className: 'yellow',
}))`
    font-size: 12px;
    color: ${(props) => props?.theme?.colors?.error || 'yellow'};
`
